import React from 'react';
import { NotificationsContent } from './NotificationsContent';
import { useAuth } from '@/contexts/AuthContext';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function SocialNotificationsPage() {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="flex flex-col items-center justify-center h-64 gap-4 px-4">
        <Bell className="h-12 w-12 text-muted-foreground" />
        <p className="text-muted-foreground text-center">
          Sign in to see your notifications
        </p>
        <Button asChild>
          <Link to="/login">Sign In</Link>
        </Button>
      </div>
    );
  }

  return <NotificationsContent />;
}
